import { render } from "./TopBarBg.vue?vue&type=template&id=4f40a84a&scoped=true"
import script from "./TopBarBg.vue?vue&type=script&lang=js"
export * from "./TopBarBg.vue?vue&type=script&lang=js"

import "./TopBarBg.vue?vue&type=style&index=0&id=4f40a84a&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f40a84a"]])

export default __exports__